<template>
  <div class="main-container">

    <div class="container">
      <div class="column-75 page-middle">

        <h2>Congratulations on Winning Four tickets to Saratoga Race Course</h2>
        <h4>Click below if you choose to accept this prize.</h4>

        <br><br>

        <button id="reward-accepted" class="win_approval--yes" @click="post_request({choice:'accepted'})">Accept</button> &nbsp; 
        <button id="reward-rejected" class="win_approval--no" @click="post_request({choice:'rejected'})">Decline</button>

        <br><br>

        <h4>Make sure to accept your prize before time runs out!</h4>
        <h2>
          <timer></timer>
        </h2>

      </div>
    </div>

  </div>
</template>

<script>
    // import {computed_values} from '../mixins/computed_values'
    import {post_request, requests_methods, validation} from "../mixins/requests";
    import {elements_classes} from '../mixins/elements_classes'

    import Timer from '../components/Timer'

    export default {
        name: "instant_win_approval",
        mixins: [post_request, requests_methods, validation, elements_classes],
        components: {
            'timer': Timer
        },
        data(){
            return{
                // this_page: 'instant_win_approval'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        }
    }
</script>

<style scoped>
</style>